import { forwardRef } from 'react';

import { motion } from 'motion/react';

const SliderBottomMotion = forwardRef(function SliderBottomMotion(
  {
    children,
    keyProp,
    className = '',
    disabled = false,
    duration = 0.25,
    stiffness = 320,
    damping = 32,
    opacity = 1,
    delay = 0,
    yAxis = '100%',
    transition = {},
    turnOffOpacityTransition = true,
    exitSlideOnly = true,
    ...rest
  },
  ref,
) {
  const exit = disabled ? false : exitSlideOnly ? { y: yAxis } : { opacity: 0 };

  return (
    <motion.div
      ref={ref}
      key={keyProp}
      initial={disabled ? false : { opacity, y: yAxis }}
      animate={disabled ? false : { opacity: 1, y: 0 }}
      exit={exit}
      className={className}
      transition={{
        duration,
        y: { type: 'spring', stiffness, damping, delay },
        opacity: turnOffOpacityTransition ? false : { duration, delay },
        ...transition,
      }}
      {...rest}>
      {children}
    </motion.div>
  );
});

export default SliderBottomMotion;
